import { render, staticRenderFns } from "./CoworkingDetail.vue?vue&type=template&id=3fa55822"
import script from "./CoworkingDetail.vue?vue&type=script&lang=js"
export * from "./CoworkingDetail.vue?vue&type=script&lang=js"
import style0 from "./CoworkingDetail.vue?vue&type=style&index=0&id=3fa55822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports